import { daysFromToday } from 'utils/date'

const MS_IN_MINUTE = 60 * 1000
const MS_IN_HOUR = 60 * MS_IN_MINUTE
const MS_IN_DAY = 24 * MS_IN_HOUR

export type CourseExpirationRemaining =
  | { kind: 'empty' }
  | { kind: 'expired' }
  | { kind: 'days'; label: string }
  | { kind: 'hoursMinutes'; hours: number; minutes: number }
  | { kind: 'minutes'; minutes: number }

export const getCourseExpirationRemaining = (
  accessibleTo: string,
  now: Date = new Date()
): CourseExpirationRemaining => {
  if (!accessibleTo) {
    return { kind: 'empty' }
  }

  const endTime = new Date(accessibleTo).getTime()
  const remainingMs = endTime - now.getTime()

  if (Number.isNaN(endTime) || remainingMs <= 0) {
    return { kind: 'expired' }
  }

  if (remainingMs < MS_IN_HOUR) {
    return {
      kind: 'minutes',
      minutes: Math.max(1, Math.ceil(remainingMs / MS_IN_MINUTE))
    }
  }

  if (remainingMs < MS_IN_DAY) {
    const hours = Math.floor(remainingMs / MS_IN_HOUR)
    const minutes = Math.floor((remainingMs % MS_IN_HOUR) / MS_IN_MINUTE)

    return { kind: 'hoursMinutes', hours, minutes }
  }

  return {
    kind: 'days',
    label: daysFromToday(accessibleTo)
  }
}
